var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-view"},[_c('div',{ref:"widget",staticClass:"widget-host",attrs:{"id":"widget"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }